<section class="card p-4">
  <div class="header">
    <h2 class="header__title">Convidados</h2>
    <div class="search">
      <p class="search__title">Buscar convidado:</p>
      <p-iconField iconPosition="left" class="ml-auto">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>
        <input pInputText [formControl]="tableFilter" placeholder="Nome" />
      </p-iconField>
    </div>
  </div>

  <div class="d-flex justify-content-center justify-content-md-end align-items-center flex-wrap gap-2 my-4">
    <app-button (btnClick)="downloadReport()" styleType="outlined" icon="pi pi-download"> Baixar Relatório </app-button>
    @if (!readOnly) {
      <app-button (btnClick)="adicionarConvidado()">
        <i class="pi pi-plus"></i>
        Adicionar novo Convidado
      </app-button>
    }
  </div>

  <div class="table-container">
    <app-guests-table
      [data]="invitations$ | async"
      [readOnly]="readOnly"
      (editGuestClick)="handleEditParticipant($event)"
      (cancelGuestClick)="handleCancelParticipant($event)"
      (resendInviteClick)="handleResendInvite($event)"
      (pageChange)="handlePageChange($event)" />
  </div>
</section>
